export default defineNuxtRouteMiddleware(to =>
{
	if( to.matched.length === 0 )
	{
		return
	}

	if( to.path !== '/' && !to.path.endsWith('/') )
	{
		return navigateTo(
			{ 
				path: to.path + '/', 
				query: to.query, 
				hash: to.hash 
			}, 
			{ redirectCode: 301 }
		)
	}
})